import React from 'react';
import { Button, Notification } from 'is24-corecss';
import { Environment } from '@/@types/environment';
import { APP_CONFIG } from '@/config';

interface AdminPageProps {
  isRequestInProgress: boolean;
  onResetNavigationDots: () => void;
  onAddAdacWp: () => void;
  hasAdacEntitlement: boolean;
  addEntitlementsFailed: boolean;
}

export const AdminPage = ({
  isRequestInProgress,
  onResetNavigationDots,
  onAddAdacWp,
  hasAdacEntitlement,
  addEntitlementsFailed,
}: AdminPageProps) => (
  <div className='grid gutter-vertical-l'>
    <div className='grid-item'>
      <Notification
        title='Admin Page Request'
        message={isRequestInProgress ? 'Waiting for response' : 'No request in action'}
        type='info'
      />
    </div>

    <div className='grid-item'>
      <Button onClick={onResetNavigationDots} appearance='primary'>
        Reset user interactions
      </Button>
    </div>
    {(APP_CONFIG.environment === Environment.SANDBOX || process.env.NODE_ENV === 'development') && (
      <>
        <div className='grid-item'>
          <Button onClick={onAddAdacWp} appearance='primary' disabled={isRequestInProgress || hasAdacEntitlement}>
            Add ADAC WP
          </Button>
        </div>
        {addEntitlementsFailed && (
          <div className='grid-item'>
            <Notification role='alert' type='error' title='Could not add entitlements. Please try again.' />
          </div>
        )}
      </>
    )}
  </div>
);
